var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ maxWidth: _vm.maxWidth, minWidth: _vm.minWidth })},[_c('apexchart',{attrs:{"width":_vm.chartWidth,"type":"donut","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }